<template>
  <modal-template :id="id" :name="name" :showModal="showModal" v-on:hide-modal="close()">
    <template slot="modalContent">
      <v-tabs v-model="activeTab" grow>
        <v-tab key="objects" ripple>Objects</v-tab>
        <v-tab key="order" ripple :disabled="objects.length<1">Order</v-tab>
        
        <v-tab-item key="objects">
          <div id="subheader">
            <v-data-table :items="objects" hide-actions class="elevation-5">
              <template slot="no-data"><tr><td colspan="100%" class="text-xs-center">Empty</td></tr></template>
              <template slot="headers" slot-scope="props">
                <th class="text-xs-left">Name</th>
                <th style="width: 70px;"></th>
              </template>
              <template slot="items" slot-scope="props">
                <td>
                  <v-text-field placeholder="Insert value" v-model="props.item['Name']" hide-details></v-text-field>
                </td>
                <td><v-btn icon @click="removeObject(props.item)"><v-icon color="pink">delete</v-icon></v-btn></td>
              </template>
            </v-data-table>
            <v-btn @click="addObject()" color="info">New Object</v-btn>
          </div>
        </v-tab-item>

        <v-tab-item key="order">
          <div :style="{'margin': '50px','overflowX': 'auto'}">
            <p style='float: left'>Most Important</p>
            <p style='float: right'>Least Important</p>
            <br>
            <Container class="drag-container" drag-class="drag-dragging" @drop="onDrop" :orientation="'horizontal'" lock-axis="x">
              <Draggable class="drag-wrapper" v-for="item in sortedObjects" :key="item.id">
                <div class="drag-item">
                  {{ item['Name'] }}
                </div>
              </Draggable>
            </Container>
          </div>
        </v-tab-item>
      </v-tabs>
    </template>
  </modal-template>
</template>

<script>
import {EventBus} from '@/event-bus.js'
import ModalTemplate from '@/components/Workspace/Methods/ModalTemplate'
import {Container, Draggable} from "vue-smooth-dnd";
export default {
  components: {
    ModalTemplate,
    Container,
    Draggable
  },
  data: () => ({
    showModal: false,
    activeTab: null,
    tabs: ['objects', 'order'],

    newId: 1,
    
    objects: [],
    sortedObjects: [],

    dirty: {},
    dataFromConnection: false,
  }),
  props: {
    id: String,
    name: String
  },
  methods: {
    clone(object) {
      return JSON.parse(JSON.stringify(object));
    },
    saveModuleData() {
      var methodAttributes = {};
      methodAttributes.input = {
        objects: this.sortedObjects
      };
      methodAttributes.output = {
        headers: ['Name'],
        description: "Sorted objects from 'Most Important' to 'Least Important'"
      };
      methodAttributes.id = this.id;
      EventBus.$emit('save-module-data', methodAttributes);
    },
    setPropertyFromInputFile(mod) {
      if(mod.newConnection) this.dataFromConnection = true;
      this.objects = mod.value;
      this.sortedObjects = this.clone(mod.value);
      this.saveModuleData();
      if(mod.newConnection) this.dataFromConnection = false;
    },
    checkIfDirty(prop) {
      if(!this.dirty[prop]) {
        this.dirty[prop] = true;
        var offset = this.tabs.indexOf(prop);
        var obj = {target: this.id, property: prop, value: this[prop], yOffset: offset};
        EventBus.$emit('generate-data-module', obj);
        return true;
      } else return false;
    },
    addObject() {
      var newObj = {'Name': '', id: ''};
      newObj.id= this.newId;
      this.newId += 1;
      this.sortedObjects.push(newObj);
      this.objects.push(newObj);
      if(!this.dataFromConnection) this.checkIfDirty('objects');
    },
    removeObject(item) {
      var index = this.objects.indexOf(item);
      if(index > -1) this.objects.splice(index, 1);
      var sortedObj = this.sortedObjects.filter(obj => {return obj.id === item.id && obj['Name'] === item['Name'];});
      var index = this.sortedObjects.indexOf(sortedObj[0]);
      if(index > -1) this.sortedObjects.splice(index, 1);
    },
    onDrop(dropResult) {
      const {removedIndex, addedIndex, payload} = dropResult;
      if(removedIndex===null && addedIndex===null) return this.sortedObjects;
      const result = [...this.sortedObjects];
      let itemToAdd = payload;
      if(removedIndex !== null) itemToAdd = result.splice(removedIndex, 1)[0];
      if(addedIndex !== null) result.splice(addedIndex, 0, itemToAdd);
      this.sortedObjects = result;
    },
    close() {
      this.saveModuleData();
      this.showModal = false;
    },
  },
  mounted: function () {
    EventBus.$on('show-modal-'+this.id, tab => {
      this.showModal = true;
      var tabId = this.tabs.indexOf(tab);
      if(tabId!==-1) this.activeTab = tabId;
    });
    EventBus.$on('update-module-'+this.id, mod => {
      this.setPropertyFromInputFile(mod);
    });
    this.saveModuleData();
  }
}
</script>

<style scoped>
  #subheader {
    margin: 20px;
    font-size: 30px;
    line-height: 1.5;
  }
  * {
    -moz-box-sizing: border-box;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
  }
  .drag-container {
    display: inline-block;
    margin: 0 auto;
  }
  .drag-wrapper {
    text-align: center;
    display: block;
    position: relative;
    padding: 20px;
    width: 140px;
    height: 140px;
    float: left;
  }
  .drag-item {
    -moz-user-select: -moz-none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -ms-user-select: none;
    user-select: none;
    cursor: grab;
    width: 100px;
    height: 100px;
    background: rgba(0, 0, 255, 0.8);
    color: white;
    text-align: center;
    padding-top: 40px;
    display: block;
    position: relative;
    z-index: 2;
  }
  .drag-dragging {
    opacity: 0.5;
  }
  table.v-table tbody td:first-child, table.v-table tbody td:not(:first-child), table.v-table tbody th:first-child, table.v-table tbody th:not(:first-child), table.v-table thead td:first-child, table.v-table thead td:not(:first-child), table.v-table thead th:first-child, table.v-table thead th:not(:first-child) {
    padding: 0 10px
  }
  table.v-table thead th {
    background-color: #f2f2f2;
    max-width: 150px;
    white-space: initial;
    word-wrap: break-word;
    color: #333333 !important;
    font-size: 13px;
    font-weight: bold;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
    border-bottom: 1px solid LightGray;
  }
  table.v-table tbody td {
    font-family: 'Roboto Mono', sans-serif !important;
    word-wrap: break-word;
    font-size: 12px;
    font-weight: normal;
    border-left: 1px dotted LightGray;
    border-right: 1px dotted LightGray;
  }
  .v-text-field {
    padding-top: 0px;
    margin-top: 0px;
  }
</style>



// WEBPACK FOOTER //
// src/components/Workspace/Methods/SortModal.vue